export default __webpack_public_path__ + "static/media/sentro-logo.fbda7c67.svg";